const labels = {
  All: { 'See the offering': "Vedere l'offerta" },
  FacilityDetails: { 'Ref: Page title': 'Dettaglio Struttura', 'Ref: Review': 'Revisione' },
  FacilitiesList: { 'Ref: Page title': 'Strutture', 'Ref: See details': 'Guarda i detagli' },
};
export default labels;
